import { useCallback } from 'react';
import { Editor, Range as SlateRange, Text as SlateText } from 'slate';
import { ReactEditor } from 'slate-react';

export const useDecorateUnfocusedSelection = (editor) => {
  return useCallback(
    ([node, path]) => {
      if (!SlateText.isText(node)) {
        return [];
      }

      const ranges = [];

      if (!ReactEditor.isFocused(editor) && editor.getPreviousSelection) {
        const selectionRange = editor.getPreviousSelection();
        if (selectionRange) {
          const nodeRange = Editor.range(editor, path);
          const intersection = SlateRange.intersection(selectionRange, nodeRange);
          if (intersection) {
            ranges.push({
              anchor: intersection.anchor,
              focus: intersection.focus,
              selection: true,
            });
          }
        }
      }

      return ranges;
    },
    [editor]
  );
};
